module.exports = __webpack_public_path__ + "assets/img/Edito_Franck-Bonin_cover.1eb411e7-ps.jpg";